import type { CollectionMechanic } from '../../models/collection-mechanic/collection-mechanic.types';
import { COLLECTION_MECHANIC } from '../../models/collection-mechanic/collection-mechanic.types';
import type { CBRPartner } from '../../models/partner/partner.types';
import type { GetUserResponse } from '../../providers/collinson/collinson.types';

export type ShopNowButtonProperties = {
  slug: CBRPartner['slug'];
  isUserBlocked: boolean;
  collinsonId: GetUserResponse['data']['id'] | null;
  merchantId: CollectionMechanic['externalReference'];
  ctaLabel: string;
  ctaLabelTrack: string;
  collectionMethodType: COLLECTION_MECHANIC;
  setErrorCallback?: (value: boolean) => void;
  className: string;
};

export type ShopNowButtonHandlerProperties = {
  isUserBlocked: boolean;
  collinsonId: string | null;
  ctaLabel: string;
  ctaLabelTrack: string;
  isUserLoggedIn: boolean;
};

export type ShopNowButtonContentfulResponse = {
  microcopyCollection: {
    items: Array<{
      key: string;
      value: string;
    }>;
  };
};

export enum CTA_LABELS {
  LOG_IN = 'shopNow.loggedInCtaLabel',
  LOG_OUT = 'shopNow.loggedOutCtaLabel',
  BLOCKED = 'shopNow.blockedCtaLabel',
  TRACKED = 'shopNow.trackedLabel',
}
